import { useState } from "react";
import { Button, ButtonSize, ButtonVariant, Input } from "shared/components";
import { Step } from "views/settings-integration/components/AddIntegrationModal/types";
import { useSettingsController } from "views/settings-integration/controller";

interface SecondStepProps {
  setCurrentStep: (step: Step) => void;
  closeModal: () => void;
}
export const SecondStep = ({ setCurrentStep, closeModal }: SecondStepProps) => {
  const { updateSettings, isUpdateSettingsPending } = useSettingsController();

  const [googleAnalyticsId, setGoogleAnalyticsId] = useState("");

  return (
    <>
      <Input
        label="GA account ID"
        required
        id="test"
        placeholder="G-XYZ"
        value={googleAnalyticsId}
        onChange={(e) => setGoogleAnalyticsId(e.target.value)}
      />

      <div className="flex justify-end gap-2 mt-4">
        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.BASE}
          onClick={() => setCurrentStep(Step.FIRST)}
        >
          Cancel
        </Button>
        <Button
          loading={isUpdateSettingsPending}
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.BASE}
          onClick={() => {
            updateSettings({ googleAnalyticsId: googleAnalyticsId }).then(
              () => {
                closeModal();
              }
            );
          }}
          disabled={!googleAnalyticsId}
        >
          Continue
        </Button>
      </div>
    </>
  );
};
